import LocalStorageConstants from '~/constants/LocalStorageConstants';
import {designParamsPresent} from '~/utils/url';
import rollbar from '~/vendor/rollbar';

export function isValidData(currentVersion) {
  try {
    const version = localStorage.getItem(LocalStorageConstants.VERSION);
    const timestamp = localStorage.getItem(LocalStorageConstants.TIMESTAMP);
    if (!version || designParamsPresent()) {
      return false;
    } else if (
      timestamp &&
      Date.now() - timestamp > LocalStorageConstants.VALID_DURATION
    ) {
      return false;
    }
    return version === currentVersion;
  } catch (e) {
    rollbar.error('Local Storage read error:', e);
    return false;
  }
}

export function localStorageWrapper(key, defaultValue) {
  let value;

  try {
    const currentValue = localStorage.getItem(key) || String(defaultValue);
    value = JSON.parse(currentValue);
    // eslint-disable-next-line no-unused-vars
  } catch (error) {
    value = defaultValue;
  }

  const setItem = newValue => {
    try {
      value = newValue;
      localStorage.setItem(key, JSON.stringify(newValue));
      return true;
      // eslint-disable-next-line no-unused-vars
    } catch (error) {
      return false;
    }
  };

  return [value, setItem];
}
